import L from 'leaflet';
import '../client/leaflet-filelayer.js';

/**
 * Adds the kml import plugin to the leaflet map.
 *
 * @param {object} leafletMap - The leaflet map object.
 */
const addImportKMLPlugin = leafletMap => {
  if (leafletMap.importKMLControl) leafletMap.removeControl(leafletMap.importKMLControl);
  const importKMLControl = L.Control.fileLayerLoad({
    // Allows you to use a customized version of L.geoJson.
    // For example if you are using the Proj4Leaflet leaflet plugin,
    // you can pass L.Proj.geoJson and load the files into the
    // L.Proj.GeoJson instead of the L.geoJson.
    layer: L.geoJson,
    // See http://leafletjs.com/reference.html#geojson-options
    layerOptions: { style: { color: 'red' } },
    // Add to map after loading (default: true) ?
    addToMap: true,
    // File size limit in kb (default: 1024) ?
    fileSizeLimit: 1024,
    // Restrict accepted file formats (default: .geojson, .json, .kml, and .gpx) ?
    formats: ['.kml']
  });
  L.Control.FileLayerLoad.LABEL = '<i class="fas fa-folder-open fa-xs"></i>';
  leafletMap.addControl(importKMLControl);
  // eslint-disable-next-line no-param-reassign
  leafletMap.importKMLControl = importKMLControl;
  // new L.Control.ourCustomControl().addTo(this.mymap);
  // this.mymap.addControl(new ourCustomControl());
};

export default addImportKMLPlugin;
